<template>
    <el-drawer
        :title="detailData.title"
        :visible.sync="detailParam.visible"
        size="520px"
        :close-on-press-escape="false"
        :wrapperClosable="false"
    >
        <div class="drawer-wrapper">
            <div class="drawer-main" v-loading="detailData.loading.main">
                <div class="drawer-body">
                    <el-form :model="detailData" ref="detailData" size="small">
                        <el-form-item
                            label="题目："
                            prop="row.subject"
                            :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
                        >
                            <el-input type="textarea" v-model="detailData.row.subject"></el-input>
                        </el-form-item>
                        <el-form-item
                            label="类型："
                            prop="row.question_type_id"
                            :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                        >
                            <el-select
                                :loading="typeData.loading"
                                v-model="detailData.row.question_type_id"
                            >
                                <el-option
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                    v-for="item in typeData.list"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <template
                            v-if="
                                detailData.row.question_type_id == 2 ||
                                detailData.row.question_type_id == 3
                            "
                        >
                            <template v-for="(row, index) in detailData.row.question_options_array">
                                <el-form-item
                                    :key="index"
                                    :label="index ? null : '选项：'"
                                    :prop="'row.question_options_array.' + index + '.content'"
                                    :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
                                >
                                    <el-input v-model="row.content">
                                        <el-button
                                            slot="prepend"
                                            :class="
                                                detailData.row.right_answer_array &&
                                                detailData.row.right_answer_array.indexOf(
                                                    row.name
                                                ) >= 0
                                                    ? 'el-option__checked'
                                                    : ''
                                            "
                                            @click="RightOption(row.name)"
                                            >{{ row.name }}</el-button
                                        >
                                        <template v-if="index > 1">
                                            <el-button
                                                icon="el-icon-close"
                                                slot="append"
                                                @click="DelOption(index)"
                                            ></el-button>
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </template>
                            <el-form-item>
                                <el-row>
                                    <el-col :span="24">
                                        <el-button
                                            type="primary"
                                            icon="el-icon-circle-plus-outline"
                                            @click="AddOption"
                                            >增加选项</el-button
                                        >
                                        <el-button @click="ResetOption">重置正确答案</el-button>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </template>
                        <el-form-item
                            label="分值："
                            prop="row.score"
                            :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
                        >
                            <el-input-number
                                v-model="detailData.row.score"
                                :min="1"
                                :max="5"
                                controls-position="right"
                            ></el-input-number>
                        </el-form-item>
                        <el-form-item label="解析：" prop="row.memo">
                            <el-input type="textarea" v-model="detailData.row.memo"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                type="primary"
                                size="small"
                                :loading="detailData.loading.submit"
                                @click="SubmitlDetail('detailData')"
                                >保 存</el-button
                            >
                            <el-button size="small" @click="detailParam.visible = false"
                                >取 消</el-button
                            >
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </el-drawer>
</template>

<script>
import { LearnData } from '@/plugin/Learn'
export default {
    inject: ['reload'],
    mixins: [LearnData],
    props: ['detailParam'],
    data() {
        return {
            typeData: {
                loading: true,
                list: []
            },
            detailData: {
                loading: {
                    main: false,
                    submit: false
                },
                title: '题目详情',
                letter: [],
                row: {
                    id: null,
                    subject: null,
                    question_type_id: null,
                    question_options_array: [
                        {
                            name: 'A',
                            content: null
                        },
                        {
                            name: 'B',
                            content: null
                        }
                    ],
                    question_options: [],
                    right_answer_array: [],
                    right_answer: [],
                    score: 1,
                    memo: null
                }
            }
        }
    },
    created() {
        this.$nextTick(() => {
            this.GetType()
        })
    },
    mounted() {
        this.$nextTick(() => {
            if (this.detailParam.row.id) {
                this.GetQuestion()
            }
        })
    },
    methods: {
        // 题库类型
        GetType() {
            if (!this.typeData.list.length) {
                this.GetTypeData({
                    data: {
                        order: 'ASC'
                    }
                }).then(res => {
                    this.typeData.loading = false
                    this.typeData.list = res.list
                    this.GetLetter()
                })
            }
        },
        GetQuestion() {
            this.detailData.loading.main = true
            this.$request({
                url: '/api/v1/question/' + this.detailParam.row.id
            }).then(res => {
                this.detailData.loading.main = false
                res.data.question_options_array = res.data.question_options
                res.data.right_answer_array = res.data.right_answer
                this.detailData.row = res.data
            })
        },
        // 26个英文字母
        GetLetter() {
            this.detailData.letter = []
            for (let i = 65; i < 91; i++) {
                this.detailData.letter.push(String.fromCharCode(i))
            }
        },
        // 正确答案
        RightOption(name) {
            if (this.detailData.row.right_answer_array.length) {
                let index = this.detailData.row.right_answer_array.indexOf(name)
                if (index >= 0) {
                    this.detailData.row.right_answer_array.splice(index, 1)
                } else {
                    this.detailData.row.right_answer_array.push(name)
                }
            } else {
                this.detailData.row.right_answer_array.push(name)
            }
            this.detailData.row.right_answer_array.sort()
        },
        // 增加选项
        AddOption() {
            this.ResetOption()
            this.detailData.row.question_options_array.push({
                name: this.detailData.letter[this.detailData.row.question_options_array.length],
                content: null
            })
        },
        // 删除选项
        DelOption(index) {
            this.ResetOption()
            this.detailData.row.question_options_array.splice(index, 1)
            this.detailData.row.question_options_array.forEach((row, index) => {
                row.name = this.detailData.letter[index]
            })
        },
        // 重置选项
        ResetOption() {
            this.detailData.row.right_answer_array = []
        },
        SubmitlDetail(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.detailData.row.question_options = JSON.stringify(
                        this.detailData.row.question_options_array
                    )
                    if (!this.detailData.row.right_answer_array.length) {
                        this.$message.error('选择正确答案')
                        return
                    } else {
                        this.detailData.row.right_answer = JSON.stringify(
                            this.detailData.row.right_answer_array
                        )
                    }
                    this.detailData.loading.submit = true
                    this.$request({
                        url: '/api/v1/question_add',
                        params: this.detailData.row
                    }).then(res => {
                        this.detailData.loading.submit = false
                        this.$message({
                            message: res.message || (res.status ? '操作失败' : '操作成功'),
                            type: res.status ? 'error' : 'success'
                        })
                        if (!res.status) {
                            this.detailParam.visible = false
                            this.$parent.GetQuestion()
                        }
                    })
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/drawer.less';
.el-option {
    &__checked {
        color: @color-primary !important;
    }
}
</style>
